<div class="pe-auto h-100 d-flex flex-column justify-content-between align-items-center mb-10" role="presentation">
  <h3 class="mb-15">No suppliers yet</h3>
  <p class="text-neutral-n7 mb-20">Add your first supplier now</p>
  <button class="cp btn btn-primary px-15 mb-20 d-flex align-items-center" (click)="addSupplier()">
    <i class="icon-add text-neutral-n1 me-10 fs-4"></i>
    Add supplier
  </button>
</div>
